GZ.funcs = {
  /**
   *  Detect transform translate support
   *  @author Jeff Falter
   *  @date   Aug 8 '12 at 17:36
   *  @URI    http://stackoverflow.com/a/11870053
   */
  Has3DSupport: function(){
    var sTranslate3D = "translate3d(0px, 0px, 0px)";

    var eTemp = document.createElement("div");

    eTemp.style.cssText = "  -moz-transform:"    + sTranslate3D +
                          "; -ms-transform:"     + sTranslate3D +
                          "; -o-transform:"      + sTranslate3D +
                          "; -webkit-transform:" + sTranslate3D +
                          "; transform:"         + sTranslate3D;
    var rxTranslate = /translate3d\(0px, 0px, 0px\)/g;
    var asSupport = eTemp.style.cssText.match(rxTranslate);
    var bHasSupport = (asSupport !== null && asSupport.length == 1);

    return bHasSupport;
  },

  rem: function(int){
    var rem = 16;

    if(this.mediaQuery("min-width", 300)){
      rem = 16 + (20 - 16) * ((window.innerWidth - 300) / (1000 - 300));
      /*
        [minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width]))
      */
    }

    if(this.mediaQuery("min-width", 1000)){
      rem = 20;
    }

    return (rem * int).toFixed(4);
  },

  mediaQuery: function(condition, px){
    if(typeof window.matchMedia != "undefined"){
      return window.matchMedia("("+ condition +": "+ px +"px)").matches;
    } else if(typeof window.msMatchMedia != "undefined") {
      return window.msMatchMedia("("+ condition +": "+ px +"px)").matches;
    } else {
      return (condition === "min-width") ? $(window).outerWidth() < px : $(window).outerWidth() > px;
    }
  }
};
